module.exports = __webpack_public_path__ + "img/kazio.53d171e9.jpg";